import styled from '@emotion/styled'

export const DisclaimerStyled = styled('div')({
  marginTop: '5px',
})
